import { render, staticRenderFns } from "./StampHistories.vue?vue&type=template&id=6200882a&scoped=true"
import script from "./StampHistories.vue?vue&type=script&lang=ts"
export * from "./StampHistories.vue?vue&type=script&lang=ts"
import style0 from "./StampHistories.vue?vue&type=style&index=0&id=6200882a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6200882a",
  null
  
)

export default component.exports